import Vue from 'vue'
import VueRouter from 'vue-router'

var elements = ["FormPage", "BPI", "FailedPage"];
elements.forEach(function(element) {
  window[element] = () => import("@/views/" + element);
});

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "formPage",
    component: FormPage,
  },
  {
    path: "/(/bpi/)?:linked:acId",
    name: "bpi",
    component: BPI,
  },
  {
    path: "/bpi/failed",
    name: "failed-page",
    component: FailedPage,
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
